import app from 'app';
import BlockSlider from 'layout/block-slider';
import FeaturedSlider from 'layout/featured-slider';

app.add({
  BlockSlider,
  FeaturedSlider,
});

app.mount();
